/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ environmentVariable: NonNullable<unknown>, appName: NonNullable<unknown> }} Components_App_Providers_Missing_Privy_DescriptionInputs */

const en_components_app_providers_missing_privy_description = /** @type {(inputs: Components_App_Providers_Missing_Privy_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Set ${i?.environmentVariable} to enable authentication in ${i?.appName}.`)
};

const de_components_app_providers_missing_privy_description = /** @type {(inputs: Components_App_Providers_Missing_Privy_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Setzen Sie ${i?.environmentVariable}, um die Authentifizierung in ${i?.appName} zu aktivieren.`)
};

const pt_br2_components_app_providers_missing_privy_description = /** @type {(inputs: Components_App_Providers_Missing_Privy_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Defina ${i?.environmentVariable} para ativar a autenticação no ${i?.appName}.`)
};

const tr_components_app_providers_missing_privy_description = /** @type {(inputs: Components_App_Providers_Missing_Privy_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.appName} içinde kimlik doğrulamayı etkinleştirmek için ${i?.environmentVariable} değerini ayarlayın.`)
};

const zh_cn2_components_app_providers_missing_privy_description = /** @type {(inputs: Components_App_Providers_Missing_Privy_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`设置 ${i?.environmentVariable} 以在 ${i?.appName} 中启用身份验证。`)
};

const zh_hk2_components_app_providers_missing_privy_description = /** @type {(inputs: Components_App_Providers_Missing_Privy_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`請設定 ${i?.environmentVariable} 以啟用 ${i?.appName} 的身分驗證。`)
};

const ko_kr2_components_app_providers_missing_privy_description = /** @type {(inputs: Components_App_Providers_Missing_Privy_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.appName}에서 인증을 사용하려면 ${i?.environmentVariable}을(를) 설정하세요.`)
};

const ru_ru2_components_app_providers_missing_privy_description = /** @type {(inputs: Components_App_Providers_Missing_Privy_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Задайте ${i?.environmentVariable}, чтобы включить аутентификацию в ${i?.appName}.`)
};

const es_419_components_app_providers_missing_privy_description = /** @type {(inputs: Components_App_Providers_Missing_Privy_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Configura ${i?.environmentVariable} para habilitar la autenticación en ${i?.appName}.`)
};

/**
* | output |
* | --- |
* | "Set {environmentVariable} to enable authentication in {appName}." |
*
* @param {Components_App_Providers_Missing_Privy_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_app_providers_missing_privy_description = /** @type {((inputs: Components_App_Providers_Missing_Privy_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_App_Providers_Missing_Privy_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_app_providers_missing_privy_description(inputs)
	if (locale === "de") return de_components_app_providers_missing_privy_description(inputs)
	if (locale === "pt-BR") return pt_br2_components_app_providers_missing_privy_description(inputs)
	if (locale === "tr") return tr_components_app_providers_missing_privy_description(inputs)
	if (locale === "zh-CN") return zh_cn2_components_app_providers_missing_privy_description(inputs)
	if (locale === "zh-HK") return zh_hk2_components_app_providers_missing_privy_description(inputs)
	if (locale === "ko-KR") return ko_kr2_components_app_providers_missing_privy_description(inputs)
	if (locale === "ru-RU") return ru_ru2_components_app_providers_missing_privy_description(inputs)
	return es_419_components_app_providers_missing_privy_description(inputs)
});